import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import { HookFormTextArea } from '@components/ReactHookFormFields/HookFormTextArea';
import { useIncidentCreation } from '@hooks/incidents';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

export const ContractQuestionForm = ({
  customTranslations,
}: ParsedEntry<IWidget>) => {
  const { t } = useCustomTranslations(customTranslations);

  const { create } = useIncidentCreation({
    postIncident: api.incidents.postGenericIncident,
    classifications: {
      classification: IncidentClassification.CONTRACTS,
      subClassification: IncidentSubClassification.QUESTION_FOR_CONTRACT,
    },
  });

  return (
    <IncidentFormWrapper<{ description: string }>
      incidentKind="ContractQuestion"
      defaultValues={{
        description: '',
      }}
      validationSchema={yup.object().shape({
        description: yup.string().required(),
      })}
      onSubmit={(values) => create({ ...values, title: t('messageTitle') })}
    >
      <HookFormTextArea
        name="description"
        type="text"
        label={{ value: t('descriptionInputLabel'), type: 'static' }}
        rows={6}
        maxLength={1800}
      />
    </IncidentFormWrapper>
  );
};
